module.exports = __webpack_public_path__ + "static/media/modal_sign_left_intro.85de1475.png";